<template>
  <PageHeader
    title="Műsorújság"
    hero-class="bg-event-calendar hidden lg:flex"
    :breadcrumb="['Műsorújság']"
  >
    <section>
      <div class="bg-white w-full">
        <ReOverlayLoader
          :loading="$fetchState.pending"
          class="py-10 lg:p-10 flex flex-col gap-5"
        >
          <nuxt-link
            v-for="(item, index) in hasBeen"
            :key="item.id + '/' + item.slug"
            class="group w-full"
            :to="'/mediatar/felvetelek/' + item.id + '/' + item.slug"
          >
            <EntityRow 
              hide-box-slot
              class="opacity-30"
            >
              <template #box>
                <div class="w-[120px]">
                  <RePictureSet
                    v-if="item.album && item.album.thumbnail"
                    :image="item.album.thumbnail"
                    :alt="item.title"
                    class="w-[120px] h-[120px]"
                    image-class="img-fluid lazyload object-cover w-full h-full"
                    sizes="60px"
                  />
                </div>
              </template>
              <template #body>
                <div class="flex flex-col lg:flex-row gap-3 w-full h-full">
                  <div class="flex flex-col w-full lg:w-9/12 justify-center">
                    <h2 class="font-source-serif-pro text-xl lg:text-3xl leading-7 font-semibold text-red group-hover:text-yellow">
                      {{ item.title }}
                    </h2>
                    <div class="mt-3 flex flex-row gap-2 flex-wrap">
                      <span
                        v-for="(performer, index2) in item.performers"
                        :key="item.id + index2"
                        class="bg-[#DCDCDC] p-1 font-semibold"
                        :class="{ 'mx-0 ': index2 === 0 }"
                      >
                        {{ performer.name }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="flex flex-row gap-1 w-full lg:w-3/12 justify-start lg:justify-end items-center h-full"
                  >
                    <nuxt-link
                      v-if="item.lyrics && item.lyrics.length > 0"
                      :to="'/mediatar/felvetelek/' + item.id + '/' + item.slug"
                      title="dalszöveg"
                    >
                      <img
                    
                        src="/img/lyric_icon.svg"
                        class="mx-auto"
                        alt=""
                      > 
                    </nuxt-link>
                    <nuxt-link
                      v-if="isAdmin()" 
                      :to="'/admin/felvetelek/felvetel/' + item.id"
                      :class="{ '!icon-disabled': item.status === 'deleted' }"
                      class="action-icon icon-yellow m-0"
                    >
                      <i
                        class="fas fa-cog"
                        title="Esemény szerkesztése"
                      />
                    </nuxt-link>
                    <p class="p-1 font-source-serif-pro">
                      <img
                        src="/img/clock_icon.svg"
                        class="pr-2 inline"
                        alt=""
                      > 
                      <!-- <span class="hidden lg:inilne">Kezdés: </span> -->
                      {{ calculateStart(nowPlayingIndex - (hasBeen.length - index) + 1) }}
                    </p>
                  </div>
                </div>
              </template>
            </EntityRow>
          </nuxt-link>

          <nuxt-link
            v-for="(item, index) in coming"
            :key="item.id + '/' + item.slug"
            class="group w-full"
            :class="{'active': recordings.data[nowPlayingIndex].id === item.id }"
            :to="'/mediatar/felvetelek/' + item.id + '/' + item.slug"
          >
            <EntityRow
              :selected-entity="recordings.data[nowPlayingIndex].id === item.id"
              hide-box-slot
            >
              <template #box>
                <div class="w-[120px]">
                  <RePictureSet
                    v-if="item.album && item.album.thumbnail"
                    :image="item.album.thumbnail"
                    :alt="item.title"
                    class="w-[120px] h-[120px]"
                    image-class="img-fluid lazyload object-cover w-full h-full"
                    sizes="60px"
                  />
                </div>
              </template>
              <template #body>
                <div
                  class="flex flex-col lg:flex-row gap-3 w-full h-full"
                >
                  <div class="flex flex-col w-full lg:w-9/12 justify-center">
                    <h2
                      class="font-source-serif-pro text-xl lg:text-3xl leading-7 font-semibold text-red group-hover:text-yellow"
                      :class="{ 
                        '!text-white': recordings.data[nowPlayingIndex].id === item.id,
                      }"
                    >
                      {{ item.title }}
                    </h2>
                    <div class="mt-3 flex flex-row gap-2 flex-wrap">
                      <span
                        v-for="(performer, index2) in item.performers"
                        :key="item.id + index2"
                        class="bg-[#DCDCDC] p-1 font-semibold"
                        :class="{ 'mx-0 ': index2 === 0 }"
                      >
                        {{ performer.name }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="flex  flex-row gap-1 w-full lg:w-3/12 justify-start lg:justify-end items-center h-full"
                  >
                    <nuxt-link
                      v-if="item.lyrics && item.lyrics.length > 0"
                      :to="'/mediatar/felvetelek/' + item.id + '/' + item.slug"
                      title="dalszöveg"
                      class="order-2 ml-2 lg:ml-0 lg:order-1"
                    >
                      <img
                    
                        src="/img/lyric_icon.svg"
                        class=" mx-auto"
                        alt=""
                      > 
                    </nuxt-link>
                    <nuxt-link
                      v-if="isAdmin()" 
                      :to="'/admin/felvetelek/felvetel/' + item.id"
                      :class="{ '!icon-disabled': item.status === 'deleted' }"
                      class="action-icon icon-yellow m-0"
                    >
                      <i
                        class="fas fa-cog"
                        title="Esemény szerkesztése"
                      />
                    </nuxt-link>
                    <p
                      class="order-1 lg:order-2 p-1 font-source-serif-pro"
                      :class="{ 
                        '!text-white': recordings.data[nowPlayingIndex].id === item.id,
                      }"
                    >
                      <img
                        src="/img/clock_icon.svg"
                        class="pr-2 inline"
                        alt=""
                      > 
                      <!-- <span class="hidden lg:inilne">Kezdés: </span> -->
                      {{ calculateStart(nowPlayingIndex + index +1) }}
                    </p>
                  </div>
                </div>
              </template>
            </EntityRow>
          </nuxt-link>


          <div class="w-full flex place-items-center place-content-center">
            <nuxt-link
              :to="'/radio/musorujsag/' + today()"
              class="link link-yellow"
            >
              Tovább a teljes műsorra
            </nuxt-link>
          </div>
        </ReOverlayLoader>
      </div>
    </section>
  </PageHeader>
</template>

<script>
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'
import EntityRow from '~/components/folkradio/EntityRow.vue'
export default {
  components: {
    PageHeader,
    ReOverlayLoader,
    RePictureSet,
    EntityRow
  },
  filters: {
    time(milliseconds) {
      const hours = milliseconds / (60 * 60);
      const absoluteHours = Math.floor(hours);
      // const h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours

      // Get remainder from hours and convert to minutes
      const minutes = (hours - absoluteHours) * 60;
      const absoluteMinutes = Math.floor(minutes);
      const m = absoluteMinutes > 9 ? absoluteMinutes : "0" + absoluteMinutes;

      // Get remainder from minutes and convert to seconds
      const seconds = (minutes - absoluteMinutes) * 60;
      const absoluteSeconds = Math.floor(seconds);
      const s = absoluteSeconds > 9 ? absoluteSeconds : "0" + absoluteSeconds;

      return /* h + ':' + */ m + ":" + s;
    }
  },
  head() {
    return {
      titleTemplate: "Műsorújság | Folkrádió",
      meta: [
        { hid: "title", name: "title", content: "Műsorújság | Folkrádió" },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: "Műsorújság | Folkrádió"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.$getDomain() + "/img/meta_default.png"
        },
        {
          hid: "description",
          name: "description",
          content: `A Folkrádió ${this.$moment().format('YYYY.MM.DD.')} napi műsora`
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: `A Folkrádió ${this.$moment().format('YYYY.MM.DD.')} napi műsora`
        }
      ]
    };
  },
  data() {
    return {
      coming: [],
      hasBeen: [],

      loading: false,
      showMoreSongs: false,
      startTimes: [],
      nowPlayingIndex: 0
    };
  },
  computed: {
    entity() {
      return this.$store.getters['getPlaylist']['entity']
    },
    recordings() {
      return this.$store.getters['getPlaylist']['recordings']
    },
    nowPlaying() {
      return this.$store.getters['getNowPlaying']
    }
  },
  watch: {
    recordings: {
      handler() {
        this.calculateNowPlaying();
      },
      deep: true
    }
  },
  async fetch(){
    if(!this.$store.getters['getPlaylist']['recordings'].data.length){
      this.$store.dispatch('loadRadioPlaylist')
    }
  },
  updated() {
  try {   
      const element = document.getElementsByClassName("active");
      console.log(element[0]);
      element[0].scrollIntoView({block: "center", inline: "nearest"});
      // window.scrollTo({ top: element[0].offsetTop - 120, behavior: 'smooth' })
    } catch (error) {
      console.log(error);
    }
  },
  beforeMount() {
    this.calculateNowPlaying();
  },
  mounted() {
    window.Echo.channel("radio").listen(".now-playing", e => {
      this.$store.commit('setNowPlaying', e.data)
      this.calculateNowPlaying();
      this.$forceUpdate()
    });
  },
  methods: {
    today() {
      return this.$moment().format("YYYY-MM-DD");
    },
    calculateNowPlaying() {
      // if(this.nowPlaying.data.length && this.recordings.data.length){
      const np = this.nowPlaying.data.find(item => {
        return item.now_playing;
      });
      let index = 0;
      if (np) {
        index = this.recordings.data.findIndex((item, index) => {
          return item.id === np.id;
        });
      }
      this.nowPlayingIndex = index === -1 ? 0 : index;
      this.calculateHasBeen();
      this.calculateComing();
      // }
    },
    calculateHasBeen() {
      this.hasBeen = this.recordings.data.filter((item, index) => {
        return index < this.nowPlayingIndex && (index >= this.nowPlayingIndex - 3);
      });
    },
    calculateComing() {
      this.coming = this.recordings.data.filter((item, index) => {
        return index >= this.nowPlayingIndex && (index < this.nowPlayingIndex + 25);
      });
    },
    timeBySeconds(seconds) {
      if (!seconds) {
        return "00:00";
      }

      // console.log((-1*(new Date).getTimezoneOffset() - 120)
      // + ' => ' 
      // +  this.$moment().startOf('day').seconds(seconds).format("HH:mm")
      // + ' => ' 
      // +  this.$moment().startOf('day').minutes((-1*(new Date).getTimezoneOffset() - 120)).seconds(seconds).format("HH:mm"))
      return this.$moment().startOf('day').seconds(seconds).format("HH:mm")
    },
    calculateStart(index) {
      if(index > this.recordings.data.length -1 || index < 0){
        return this.timeBySeconds(0)
      }
      
      let start = 0
      if(this.startTimes.length){
        start = this.startTimes.length - 1 
      }
      for(let i = start; i <= index; i++){
        if(!this.startTimes.length){
            this.startTimes[i] = this.recordings.data[i].length  
        } else {
          if(!this.startTimes[i]){
            this.startTimes[i] = this.startTimes[i - 1] + this.recordings.data[i].length  
          }
        }
      }
      
      return this.timeBySeconds(this.startTimes[index - 1] ? this.startTimes[index - 1] : 0);
    }
  }
};
</script>